module.exports = {
  m: { api: 'm', human: 'männlich' },
  w: { api: 'w', human: 'weiblich' }
}
